import { OptionsPromoBoxItemType } from "@/types/OptionType";
import Image from "next/image";
import { Button } from "../../Button/Button";
import styles from "./NavbarPromoBox.module.scss";
import { customSanitize } from "@/utils/customSanitize";
import React from "react";

interface NavbarPromoBoxProps {
  data: OptionsPromoBoxItemType;
  extraClass?: string;
  isNobleElements?: boolean;
}

export const NavbarPromoBox = React.forwardRef<
  HTMLElement,
  NavbarPromoBoxProps
>(({ data, extraClass = "", isNobleElements = false }, ref) => {
  if (!data) return null;

  return (
    <div
      className={`${styles["navbar-promo-box"]} is-box ${extraClass}`}
      data-is-noble={isNobleElements}
      // style={
      //   {
      //     "--promo-bg":
      //       data.background ||
      //       "linear-gradient(135deg, #0d5ea8 0%, #063158 100%)",
      //   } as React.CSSProperties
      // }
    >
      <div className={styles["top-row"]}>
        <div className={styles["content"]}>
          {data.title && (
            <span
              className={styles["title"]}
              dangerouslySetInnerHTML={{ __html: customSanitize(data.title) }}
            />
          )}
          {data.text && (
            <p
              className={styles["text"]}
              dangerouslySetInnerHTML={{ __html: customSanitize(data.text) }}
            />
          )}
        </div>
        {data.image && (
          <div className={styles["promo-image-wrapper"]}>
            <Image
              src={data.image.url}
              alt={data.image.alt || ""}
              fill
              sizes="(max-width: 767px) 110px, (max-width: 1023px) 200px, 110px"
            />
          </div>
        )}
      </div>

      <div className={styles["bottom-row"]}>
        {data.link_extended &&
          data.link_extended.link &&
          typeof data.link_extended.link === "object" && (
            <Button
              invert
              ref={ref}
              type="primary"
              href={data.link_extended.link.url}
              target={data.link_extended.link.target}
              className={styles["promo-btn"]}
              tabIndex={-1}
            >
              {data.link_extended.link.title}
            </Button>
          )}
      </div>
    </div>
  );
});

NavbarPromoBox.displayName = "NavbarPromoBox";
